'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    InputButton: ()=>InputButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const field_namespaceObject = require("@base-ui-components/react/field");
const external_react_namespaceObject = require("react");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const utils_cjs_namespaceObject = require("../Tooltip/utils.cjs");
const external_InputButton_variants_cjs_namespaceObject = require("./InputButton.variants.cjs");
const external_InputButtonWrapper_cjs_namespaceObject = require("./InputButtonWrapper.cjs");
function InputButton({ label, placeholder, value, isLabelHidden, helperText, errorText, iconLeft, iconRight, emphasis, size, className, isDisabled, errorMessage, onClick, toggleEvent, ref, ...props }) {
    const [internalToggleState, setInternalToggleState] = (0, external_react_namespaceObject.useState)(false);
    const tooltipSideOffset = (0, utils_cjs_namespaceObject.getTooltipSideOffset)(size, true);
    const hasPlaceholder = Boolean(placeholder);
    const hasValue = Boolean(value);
    const isToggled = toggleEvent ?? internalToggleState;
    const styles = (0, external_InputButton_variants_cjs_namespaceObject.inputButtonVariants)({
        emphasis,
        size,
        hasPlaceholder,
        hasValue,
        isDisabled,
        error: Boolean(errorMessage)
    });
    const buttonText = value ?? placeholder ?? '';
    const handleButtonClick = (e)=>{
        if (isDisabled) return;
        if (void 0 === toggleEvent) setInternalToggleState((prev)=>!prev);
        if (onClick) {
            e.stopPropagation();
            onClick(e);
        }
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(field_namespaceObject.Field.Root, {
        className: (0, cn_cjs_namespaceObject.cn)(styles.root(), className),
        disabled: isDisabled,
        tabIndex: isDisabled || !onClick ? -1 : 0,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(field_namespaceObject.Field.Control, {
                render: (controlProps)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_InputButtonWrapper_cjs_namespaceObject.InputButtonWrapper, {
                        ...controlProps,
                        ...props,
                        styles: styles,
                        iconLeft: iconLeft,
                        iconRight: iconRight,
                        handleButtonClick: handleButtonClick,
                        isDisabled: isDisabled,
                        buttonText: buttonText,
                        errorMessage: errorMessage,
                        tooltipSideOffset: tooltipSideOffset,
                        label: label,
                        isLabelHidden: isLabelHidden,
                        isToggled: isToggled,
                        ref: ref
                    })
            }),
            helperText || errorText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: styles.textSlot(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(field_namespaceObject.Field.Error, {
                        match: Boolean(errorText),
                        className: styles.errorTextSlot(),
                        "aria-live": "assertive",
                        children: errorText
                    }),
                    !errorText && helperText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(field_namespaceObject.Field.Description, {
                        className: styles.helperTextSlot(),
                        "aria-live": "polite",
                        children: helperText
                    }) : null
                ]
            }) : null
        ]
    });
}
exports.InputButton = __webpack_exports__.InputButton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "InputButton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
